import React, { useEffect, useState } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import arrow from "../../src/assets/images/arrow-right.png";
import { Button, Grid } from "@mui/material";
import ModalBottomSheet from "./ModalBottomSheet";
import "../pages/paymentPage.css";
import { useNavigate, createSearchParams, useLocation } from 'react-router-dom';
import DataServices from "./DataServices";
import NoDataFound from "./NoDataFound";
import Loader from "./Loader";
import { useGlobalState } from "../globalStyle";

export default function Cards({ cardDetails, userData, formattype, isBottomSheetEnabled, secretPlansData }) {

  const [cardData, setCardData] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [cardInfo, setCardInfo] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const leadSquaredBody = useGlobalState("leadSquaredDataVal")[0];
  const paymentBaseUrl = useGlobalState("PAYMENTBASEURL")[0];
  const search = useLocation().search;
  const params = new URLSearchParams(search);

  let urlProductPlanId = params.get("product_plan_id");
  let urlClientCode = params.get("client_code");
  let urlMobile = params.get("client_mobile");
  let urlClientEmail = params.get("client_email");
  let urlFirstName = params.get("first_name");
  
  if (urlClientEmail !== null && urlMobile !== null) {
    userData.clientCode = userData.clientCode !== '' ? userData.clientCode : urlClientCode;
    userData.client_email = userData.client_email !== '' ? userData.client_email : urlClientEmail;
    userData.mobile = userData.mobile !== '' ? userData.mobile : urlMobile;
    userData.first_name = userData.first_name !== '' ? userData.first_name : urlFirstName;
  }

  useEffect(() => {
    if (cardDetails.length > 0 && secretPlansData === "null") {
      handleStoxCalls(cardDetails[0].child)
    } else if (cardDetails.length > 0 && (secretPlansData === "false" || secretPlansData === "null")) {
      handleStoxCalls(cardDetails[0].child)
    } else if (cardDetails.length > 0 && secretPlansData === "true") {
      const filteredCardData = cardDetails.filter(cardFilteredData => cardFilteredData.visible !== false);
      if (filteredCardData.length > 0) {
        handleStoxCalls(filteredCardData)
      }
    }
    else {
      if (cardDetails.length > 0) {
        handleStoxCalls(cardDetails[0].child)
      }
    }
    setLoading(false)
  }, [cardDetails]);

  const handleStoxCalls = (cardData) => {
    const updatedCardData = cardData.map(item => {
      if (item.code.includes("PROTIPS")) {
        return { ...item, code: item.code.replace("PROTIPS", "STOXCALLS") };
      }
      return item;
    });
    setCardData(updatedCardData);
  }


  const handleOpenDialog = (cardValue) => {
    const res = cardData.filter((val) => val === cardValue);
    setCardInfo(res);
    setIsOpen(true);
  };

  let isPaymentGateway = "";

  const submit = async (cardValue) => {
    try {
      const data = await DataServices.productData();
      if (data) {
        const paymentConfig = await DataServices.paymentMenthod(paymentBaseUrl);
        const res = cardData && cardData.filter((val) => val === cardValue);
        const isOneTimePurchase = data && data.products.some(product => {
          return product.child.some(child => {
            product.child.map(val => {
              if (val.code === res[0].code) {
                isPaymentGateway = val.paymentGateway;
              }
            })
            return child.code === cardData[0]['code'] && !cardData[0]['recurring'];
          });
        });

        let currentPaymentGatewayType;
        let paymentGateway;
        if (isOneTimePurchase) {
          currentPaymentGatewayType = "onetime";
          paymentGateway = paymentConfig && paymentConfig.data.currentPaymentGateway.onetime;
        } else {
          currentPaymentGatewayType = "subscription";
          paymentGateway = paymentConfig && paymentConfig.data.currentPaymentGateway.subscription;
        }
        if (currentPaymentGatewayType && paymentGateway) {
          cardData.map((obj) => {
            return navigate({
              pathname: isPaymentGateway ? isPaymentGateway.toLowerCase() : paymentGateway.toLowerCase(),
              search: `?${createSearchParams({
                clientCode: userData && userData.clientCode ? userData.clientCode : '',
                mobile: userData && userData.mobile ? userData.mobile : '',
                mailId: userData && userData.client_email ? userData.client_email : '',
                first_name: userData && userData.first_name ? userData.first_name : '',
                planCode: cardValue.code || urlProductPlanId,
                paymentMethod: currentPaymentGatewayType,
                formattype: formattype,
                ...leadSquaredBody
              })}`,
            });
          });
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div className="card-wrapper">
      <Grid container>
        <Grid item xs={12} sm={12}>
        {loading ? (
            <p style={{ textAlign: 'center', fontWeight: 'bold' }}>Loading...</p>
          ) : cardData && cardData.length === 0 ? (
            <div className="no-product">
              <Loader />
            </div>
          ) : (
            cardData &&
            cardData.map((val, i) => (
              <Card style={{ border: formattype === "custom" ? '0.5px solid grey' : "" }} key={i} sx={{ mt: 2 }} onClick={() => isBottomSheetEnabled === "true" ? submit(val) : handleOpenDialog(val)}>
                <CardContent>
                  <div className="wrapper-card">
                    <div className="product-card-plan">
                      {val.plan}
                    </div>
                    {formattype === 'custom' ? val.price <= val.afterDiscount ? null : <div className="product-card-save">
                      Save {Math.floor(val && val.offerPrice ? ((val.price - val.offerPrice) / val.price) * 100 : ((val.price - val.afterDiscount) / val.price) * 100)} %
                    </div> : null}
                  </div>
                  <div
                    className="description"
                  >
                    {val.description && val.description}
                  </div>
                  <div className="border-bottom"></div>
                  <div className="price-wrapper">
                    {
                      formattype === 'custom' ?
                        <div className="format-product-card">
                          <div className="format-price-container">
                            {
                              val.price && val.price !== val.afterDiscount ? (<div className="format-pr-price-container">
                                <div className="format-cut-price">
                                  <span className="format-strikediag format-withpadding">₹{val.price && val.price.toLocaleString()}</span>
                                </div>
                              </div>) : (null)
                            }

                            <div className="format-pr-real-price">
                              ₹{val.offerPrice ? val.offerPrice && val.offerPrice.toLocaleString() : val.afterDiscount.toLocaleString()}
                            </div>
                            <div className="format-product-card-gst" >{val.data.displayText} + GST</div>
                          </div>
                          <Button style={{ backgroundColor: 'blue', textTransform: "none" }} variant="contained" color="primary" size="large">
                            <span>Pay now</span></Button>
                        </div>
                        : <>
                          <div className="product-card">
                            <Grid container>
                              <Grid item xs={12} sm={6}>
                                <div className="price-container">
                                  <div style={{ display: 'flex' }}>
                                    <div className="pr-real-price" style={{ display: 'flex' }}>
                                      <p>₹{val.offerPrice ? val.offerPrice && val.offerPrice.toLocaleString() : val.afterDiscount.toLocaleString()}</p>
                                    </div>
                                    <div className="yearly-gst">
                                      <div className="card-gst"> + GST</div>
                                    </div>
                                    <div style={{ paddingTop: '4px' }}>
                                      {
                                        val.price && val.price !== val.afterDiscount ? <>
                                          <div className="pr-price-container">
                                            <div className="cut-price">
                                              <span className="strikediag withpadding">₹{val.price && val.price.toLocaleString()}</span>
                                            </div>
                                          </div>
                                        </> : null
                                      }
                                    </div>
                                  </div>
                                </div>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <div className="learn-more-wrapper">
                                  <div className="learn-more">
                                    <span>{val.ctaButton ? val.ctaButton : "Learn More"}</span>
                                  </div>
                                  <img
                                    src={arrow}
                                    alt="arrow"
                                    className="arrow"
                                  />
                                </div>
                              </Grid>
                            </Grid>
                          </div>
                        </>
                    }
                  </div>
                </CardContent>
              </Card>
            ))
          )}
          <ModalBottomSheet
            open={isOpen}
            cardInfo={cardInfo && cardInfo}
            subPlans={cardDetails && cardDetails}
            handleClose={() => setIsOpen(false)}
            usersInfo={userData && userData}
            formattype={formattype}
          />
        </Grid>
      </Grid>
    </div>

  );
}
